import axios from 'axios'
import config from '../config'
import helper from '../helpers'
import store from '../store'


export default {
  prepareRequestData (txType, data) {
    let payLoad = data;
    const env = config.env;
    payLoad.countyId = config[env].countyId;

    payLoad.requestHeader = {
      appId: config.appId,
      appVersion: config.appVersion,
      txType: txType,
      txTime: helper.now()
    };

    return payLoad;
  },
  request (txType, data = null) {
    const env = config.env;
    const url = config[env].serverURI;

    const method = 'post';
    let requestData = this.prepareRequestData(txType, data);

    return axios({
      method: method,
      url: url,
      data: requestData
    }).then(result => {
      if (result.data.status === '11') {
        store.commit('SET_USER', null);
        store.commit('SET_TOKEN', null);

        if (window.localStorage) {
          window.localStorage.removeItem('user');
          window.localStorage.removeItem('token')
        }
        window.location.replace('/')
      } else {
        return result
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js